import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import EmailField from "../../../components/Fields/EmailField";
import SelectListField from "../../../components/Fields/SelectListField";
import TextboxField from "../../../components/Fields/TextboxField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import UserModel from "../../../models/UserModel";
import DataService from "../../../services/data.service";
import { BusinessPartnerPopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";

interface BusinessPartnerUserModel {
    businessPartnerId: number
    user: UserModel
    functionalRoleId: number
}

const AddBusinessPartnerUserPopup: React.FC<BusinessPartnerPopupProps> = ({ show, onHide, businessPartnerId, businessPartnerTypeId }) => {
    const [serverErrors, setServerErrors] = useState<DataResult<BusinessPartnerUserModel>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<BusinessPartnerUserModel>({
        businessPartnerId: businessPartnerId,
        user: {
            id: 0,
            name: '',
            loginName: '',
            email: '',
            isEnabled: true,
            isLocked: false,
            concurrencyId: ''
        },
        functionalRoleId: 0
    });

    const contactpersons = useSelectListOptions('api/v1/selectlist/Contactpersons?businessPartnerId=' + businessPartnerId, '-- Select contactperson');
    const functionalRoles = useSelectListOptions('api/v1/selectlist/FunctionalRoles?businessPartnerTypeId=' + businessPartnerTypeId, '-- Select workflow role');
    const languages = useSelectListOptions('api/v1/selectlist/Languages', '-- Select language');

    function submit() {
        if (formData) {
            DataService
                .create<BusinessPartnerUserModel>(`api/v1/BusinessPartnerUsers`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        if (onHide)
                            onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'contactpersonId', label: 'Contactperson', labelSize: 2},
            { name: 'functionalRoleId', label: 'Workflow role', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
            { name: 'user.name', label: 'Name', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
            { name: 'user.loginName', label: 'Login name', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
            { name: 'user.email', label: 'Email', labelSize: 2 },
            { name: 'user.language', label: 'Language', labelSize: 2 },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add Login'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('contactpersonId')} options={contactpersons} />
                <SelectListField {...getFieldProps('functionalRoleId')} options={functionalRoles} />
                <TextboxField {...getFieldProps('user.name')} />
                <TextboxField {...getFieldProps('user.loginName')} />
                <SelectListField {...getFieldProps('user.language')} options={languages} />
                <EmailField {...getFieldProps('user.email')} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton text='Add' {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default AddBusinessPartnerUserPopup;